import { useOpenVerify } from '@pages/personal/client/editor-page/model.ts';

export const useOpenPhoneVerify = () => {
  const { doOpenVerificationModal, doCloseVerificationModal, state } =
    useOpenVerify('phoneVerifyModalState');
  return {
    openPhoneVerificationModal: doOpenVerificationModal,
    closePhoneVerificationModal: doCloseVerificationModal,
    state,
  };
};
